module.exports = __webpack_public_path__ + "static/media/DropOffDRVM.d0ddfd09.png";